import { httpRequest } from "@services/http";
import { Pricesheet } from "@models/pricesheet.model";
import { PricesheetSerializer } from "@models/serializers/pricesheetSerializer";

export interface CreatePricesheetPayload {
  base_price: number;
  is_active?: boolean;
}

export class CommandCreatePricesheet {
  async run(contractId: number, payload: CreatePricesheetPayload): Promise<Pricesheet> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return PricesheetSerializer.fromJson(response);
  }
}
